import * as React from 'react';

import {
    Container,
} from 'reactstrap';

type Props = {
    children?: React.ReactNode;
};

export const MessageBanner: React.FC<Props> = (props): React.ReactElement => {
    return (
        <div 
            style={{ height: 'fit-content' }} 
            className={`contained-content control-region control-region-lender`}
        >
            <Container
                className={`data-container  data-container-primary message-banner gx-0`}
                fluid
            >
                {props.children}
            </Container>
        </div>
    );
}
